<template>
  <div id="app" class="app-container">
    <!-- 主内容区域 - 使用绝对定位确保不产生滚动条 -->
    <div class="main-content">
      <!-- 优化点：去掉 fullPath key，改用 path 或不加 key，避免过度重建 -->
      <router-view :key="$route.path" />
    </div>

    <!-- 备案信息使用绝对定位固定在底部 -->
    <div class="icp-footer-global">
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="icp-link">
        备案号:蜀ICP备2024097752号-2
      </a>
    </div>
  </div>
</template>

<script>
// 如果未使用水印，可注释或删除该导入
// import watermark from "@/untils/watermark";

export default {
  data(){
    return {
      show:true,
    }
  },
  /*  mounted() {
    if (localStorage.getItem('menuCollapsed') === null) {
      localStorage.setItem('menuCollapsed', 'false');
    }
  },*/
  methods:{

    adjustLayoutHeight() {
      // 强制重新计算布局高度
      window.dispatchEvent(new Event('resize'));
    }
  }
}
</script>

<style lang="less" scoped>
@media print {
  /* 你想要覆盖的全局打印样式 */
  .no-print { display: none !important; }
}
/* 重置所有元素的盒模型 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* 关键修改：确保根元素不产生滚动条 */
html, body, #app {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden; /* 关键：防止根元素出现滚动条 */
}

.app-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden; /* 关键：防止容器滚动 */
}

.main-content {
  flex: 1;
  min-height: 0; /* 关键：允许flex容器收缩 */
  overflow: hidden; /* 关键：防止内容区域外部滚动 */
  position: relative;
}

/* 备案信息使用绝对定位固定在视口底部 */
.icp-footer-global {
  position: fixed; /* 改为fixed定位，相对于视口 */
  bottom: 0;
  left: 0;
  right: 0;
  height: 20px;
  background: #f8f9fa;
  border-top: 1px solid #e4e7ed;
  text-align: center;
  font-size: 12px;
  color: #909399;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  z-index: 1000;

  .icp-link {
    color: #606266;
    text-decoration: none;
    transition: color 0.3s;
    line-height: 1;
  }

  .icp-link:hover {
    color: #409eff;
  }
  /* 移动端通用适配 */
  @media (max-width: 768px) {
    html {
      font-size: 14px; /* 调整基础字体大小 */
    }

    body {
      -webkit-text-size-adjust: 100%; /* 防止字体缩放 */
      -webkit-tap-highlight-color: transparent; /* 移除点击高亮 */
    }
  }

  /* 触摸友好样式 */
  .touch-friendly {
    min-height: 44px;
    min-width: 44px;
    padding: 8px 12px;
  }

  /* 防止页面缩放 */
  @media (max-width: 768px) {
    input, select, textarea {
      font-size: 16px !important; /* 防止iOS缩放 */
    }
  }
}
</style>